import axios from "axios";
import {
  WR_CLOSE,
  WR_SET_JOIN_ROOM_FAIL,
  WR_SET_JOIN_ROOM_REQUEST,
  WR_SET_JOIN_ROOM_SUCCESS,
} from "../constants/waitingRoomConstants";
import { API_SET_JOIN_ROOM } from "../init/urlApi";
import { userDataLocalStorage } from "../../../general/functions/base64Function";

export const CloseWatingRoom = () => async (dispatch) => {
  dispatch({
    type: WR_CLOSE,
  });
};

export const SetJoinRoom = () => async (dispatch) => {
  const { token, session } = userDataLocalStorage();
  let d = session.split("-");
  let projectCode = [d[0], d[1]].join("-");
  let sessionId = d[2];
  try {
    dispatch({
      type: WR_SET_JOIN_ROOM_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data: data } = await axios.post(
      API_SET_JOIN_ROOM(projectCode, sessionId),
      {},
      config
    );

    dispatch({
      type: WR_SET_JOIN_ROOM_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: WR_SET_JOIN_ROOM_FAIL,
      payload: message,
    });
  }
};
